import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import FuelSupplyForm from '../Forms/FuelSupplyForm';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { getFuelSupplyListFilter, getFuelSupplyTypeCode } from '../../../../slices/thunks';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { Link } from 'react-router-dom';
import FuelSupplyFilesModal from '../Modals/FuelSupplyFilesModal';
import ReceiveFuelSupplyModal from '../Modals/ReceiveFuelSupply';

const AddEditFuelSupplyReceptionModal = ({ establishment_id, isOpen, handleToggleModal, }) => {
	const dispatch = useDispatch();

	const [list, setList] = useState(null);

	const selectorFuelSupplyTypeCode = createSelector(
		state => state.FuelSupplyType,
		data => ({
			itemFuelSupplyTypeDetail: data.itemFuelSupplyTypeDetail,
		})
	);
	const { itemFuelSupplyTypeDetail } = useSelector(selectorFuelSupplyTypeCode);

	const selectorFuelSupply = createSelector(
		state => state.FuelSupply,
		data => ({
			fuelSupplyListReception: data.fuelSupplyListFilter,
			isLoadingList: data.isLoadingList,
			isFuelSupplySuccess: data.isFuelSupplySuccess,
		})
	);

	const { fuelSupplyListReception, isLoadingList } = useSelector(selectorFuelSupply);


	useEffect(() => {
		const fetchFuelSupplyData = async () => {
			await dispatch(getFuelSupplyTypeCode('output_transfer'));
			if (itemFuelSupplyTypeDetail) {
				dispatch(getFuelSupplyListFilter({
					transfer_establishment_id: establishment_id,
					fuel_supply_type_id: itemFuelSupplyTypeDetail._id,
					received: false
				}));
			}
		};

		fetchFuelSupplyData();
	}, [isOpen]);



	useEffect(() => {
		const fetchAndSortFuelSupplyList = async () => {
			// Ordena la lista y asigna el resultado al estado
			const sortedFuelSupplyList = [...fuelSupplyListReception].sort(
				(a, b) => new Date(b.creation_date) - new Date(a.creation_date)
			);
			// Actualiza el estado list
			setList(sortedFuelSupplyList);
		};

		fetchAndSortFuelSupplyList();
	}, [fuelSupplyListReception]);


	const [dataFuelSupply, setDataFuelSupply] = useState({});

	const [modalFilesFuelSupply, setModalFilesFuelSupply] = useState(false);
	function handleToggleModalFilesFuelSupply() {
		setModalFilesFuelSupply(!modalFilesFuelSupply);
	}

	const handleClickFilesFuelSupply = data => {
		setDataFuelSupply(data);
		handleToggleModalFilesFuelSupply();
	};

	const [modalReceiveFuelSupply, setModalReceiveFuelSupply] = useState(false);
	function handleToggleModalReceiveFuelSupply() {
		setModalReceiveFuelSupply(!modalReceiveFuelSupply);
	}

	const handleClickReceiveFuelSupply = data => {
		setDataFuelSupply(data);
		handleToggleModalReceiveFuelSupply();
	};


	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'beachCleaning',
				columnDefType: 'display',
				 size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const data = cellProps.row.original;
													handleClickReceiveFuelSupply(data);
												}}
											>
												<i className={`${Icons.new} align-bottom me-2 text-muted`}></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const data = cellProps.row.original;
													handleClickFilesFuelSupply(data);
												}}
												title='Ver Documentos'
											>
												<i className='ri-file-search-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Origen', accessorKey: 'origin',  width: '1%',
				Cell: ({ row }) => {
					return row.original.establishment.name.toString();
				},
			},
			{
				header: 'Cantidad', accessorKey: 'amount', width: '1%', dataType: 'separator',
				Cell: ({ row }) => {
					const formattedNumber = row.original.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
					return (
						<span className="badge bg-success">{formattedNumber}</span>
					);
				}
			},
			{ header: 'Unidad', accessorKey: 'unit_measurement.name', width: '1%' },
			{ header: 'Tipo de Combustible', accessorKey: 'fuel_type.name', width: '1%' },
			{ header: 'Guía de Despacho', accessorKey: 'document_number', width: '1%' },
			{ header: 'Observación', accessorKey: 'observation', },
		],
		[establishment_id, fuelSupplyListReception]
	);

	return (
		<React.Fragment>
			<Modal
				isOpen={isOpen}
				toggle={handleToggleModal}
				size='xl'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader toggle={handleToggleModal}>
					Recepción de Combustible
				</ModalHeader>
				<ModalBody>
					<ODataGrid
						columns={columns}
						data={list || []}
						isLoadingData={isLoadingList}
					/>
				</ModalBody>

			</Modal>

			<FuelSupplyFilesModal
				dataFuelSupply={dataFuelSupply}
				isOpen={modalFilesFuelSupply}
				handleToggleModal={handleToggleModalFilesFuelSupply}
			/>

			<ReceiveFuelSupplyModal
				dataFuelSupply={dataFuelSupply}
				isOpen={modalReceiveFuelSupply}
				establishment_id={establishment_id}
				handlerToggleModal={handleToggleModalReceiveFuelSupply}
			/>

		</React.Fragment>
	);
};

export default AddEditFuelSupplyReceptionModal;
